import React from 'react';
import {Edit, List} from 'components';
import {useNamedSelector} from 'helpers';

export function LifestyleGoalActions() {
  const goal = useNamedSelector('clarity.goals', { category: 'contribution' });
  const activities = useNamedSelector('clarity.activities', { category: 'contribution' });
  return (
    <List tiny-gutter>
      <p>What is a lifestyle goal you want to set for yourself? Something that would get you closer to your ideal lifestyle.</p>
      <Edit value={goal.name} setValue={goal.update} />
      <List.Title>What are two fun activities you can do this (or every) week to make it more enjoyable?</List.Title>
      <Edit name="0" value={activities.first} setValue={activities.update} />
      <Edit name="1" value={activities.second} setValue={activities.update} />
    </List>
  );
}
